import React, { useState } from "react";
import { FaPrint } from "react-icons/fa6";
import { FaBan } from "react-icons/fa6";
import "./reportTemperature.css";
import Swal from "sweetalert2";
import NewBilling from "./newBilling";
import Billing from ".";
import Choices from "choices.js";

function ReportTemperature() {
  const [showNewBilling, setShowNewBilling] = useState(false);

  const goBackToBilling = () => {
    setShowNewBilling(false);
  };

  const handleNuevaFactura = () => {
    setShowNewBilling(true);
  };

  if (showNewBilling) {
    return <NewBilling />;
  }

  if (showNewBilling) {
    return '';
    // return <Billing />;
  }

  const impresionTicket = () => {
    const now = new Date();
    const fechaHora = now.toLocaleString("es-MX");

    // Datos ficticios
    const detalles = [
      { concepto: "Manejo de carga", monto: 259.5 },
      { concepto: "Screening", monto: 45.5 },
    ];

    const subtotal = 305.0;
    const iva = 48.8;
    const total = 353.8;

    const totalEnLetra =
      "Trescientos cincuenta y tres pesos con ochenta centavos";

    const tableRows = detalles
      .map(
        (item) => `
            <tr>
              <td style="text-align: start;">${item.concepto}</td>
              <td style="text-align: center;">$${parseFloat(item.monto).toFixed(
                2
              )}</td>
            </tr>
          `
      )
      .join("");

    const htmlContent = `
            <div id="ticketContent" style="font-family: Arial, sans-serif; text-align: left; padding: 10px;">
              <h3 class="no-print" style="text-align: start; margin-bottom: 10px;"><strong>Ticket Salida</strong></h3>
              <div style="text-align: center; margin-bottom: 10px;">
                <img src="/img-Ticket-Billing/logo-azul.svg" alt="Imagen-Aeromexico" style="height: 60px;" />
              </div>
        
              <hr style="border: 1px solid black;" />
        
              <p style="text-align: center;">Aerovías de México S.A de C.V.</p>
              <p style="text-align: center;">AME123456I89</p>
              <p style="text-align: center;">Col. Cuauhtémoc, C.P. 06500, Ciudad de México</p>
              <p style="text-align: center;">Paseo de la Reforma 243 Piso 25</p>
        
              <hr style="border: 1px solid black;" />
              <p style="text-align: center;">Ciudad de México, ${fechaHora}</p>
              <hr style="border: 1px solid black;" />
        
              <p style="text-align: center; font-weight: bold;">Folio: 1234567</p>
        
              <p><strong>Master:</strong> 123-45678901</p>
              <p><strong>Valor aduana:</strong> $5,000.00</p>
              <p><strong>House:</strong> 987654321</p>
              <p><strong>Piezas:</strong> 10</p>
              <p><strong>Peso:</strong> 250 kg</p>
              <p><strong>Agente/Almacén:</strong> LOGISTIK SA DE CV</p>
        
              <hr style="border: 1px solid black;" />
        
              <table class="table fondo-headBillingMonto">
                <thead>
                  <tr>
                    <th style="border-bottom: 1px solid #000;">Cargo</th>
                    <th style="border-bottom: 1px solid #000;">Importe</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                  <tr class="bor-bot">
                    <td style="font-weight: bold; text-align: center;">Subtotal</td>
                    <td style="text-align: center;">$${subtotal.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold; text-align: center;">IVA 16%</td>
                    <td style="text-align: center;">$${iva.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold; text-align: center;">Total</td>
                    <td style="text-align: center;">$${total.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
        
              <hr style="border: 1px solid black;" />
              <p style="text-align: left; text-transform: uppercase;"><small>(${totalEnLetra} / 100 M.N.)</small></p>
        
              <h3 style="text-align: left;">Datos a facturar</h3>
              <p style="text-align: left;">Cliente</p>
              <p><strong>Nombre:</strong> Transportes Globales MX</p>
              <p><strong>RFC:</strong> TGM123456ABC</p>
              <p><strong>Uso CFDI:</strong> G03 - Gastos en general</p>
              <p><strong>Condiciones de pago:</strong> Contado</p>
              <p><strong>Método de pago:</strong> PUE - Pago en una sola exhibición</p>
              <p><strong>Cuenta de pago:</strong> 1234</p>
              <p><strong>Observaciones:</strong> Ninguna</p>
              <p><strong>Usuario:</strong> Ezequiel Bernal</p>
        
              <hr style="border: 1px solid black;" />
              <p style="text-align: center;">FIRMA</p>
        
              <div style="text-align: right; margin-top: 30px;">
                <button id="btn-imprimir-ticket" class="btnn">
                  Imprimir
                </button>
              </div>
            </div>
          `;

    Swal.fire({
      title: "",
      html: htmlContent,
      showConfirmButton: false,
      customClass: {
        popup: "ticket-modal",
      },
      width: 500,

      didOpen: () => {
        const btnImprimir = document.getElementById("btn-imprimir-ticket");
        if (btnImprimir) {
          btnImprimir.addEventListener("click", () => {
            const content = document.getElementById("ticketContent").innerHTML;
            const printWindow = window.open("", "", "width=800, height=900");
            printWindow.document.write(`<html>
                <head>
                  <title>Imprimir Ticket</title>
                  <style>
                    body { font-family: Arial, sans-serif; padding: 10px; }
                    table { width: 100%; border-collapse: collapse; }
                    th, td { padding: 4px; }
                    hr { border: 1px solid black; }
                    button { display: none; } /* Ocultar botón al imprimir */
                    @media print {
                    .no-print {
                    display: none !important;
                    }
                    }
                  </style>
                </head>
                <body>
                  ${content}
                </body>
              </html>`);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
          });
        }
      },
    });
  };

  // const deleteFacturaTemp = (goBackToBilling) => {
  //   Swal.fire({
  //     title: "Cancelación",
  //     html: `<p><strong>Esta acción es irreversible</strong></p>
  //                 <p>Si deseas continuar, selecciona el motivo de cancelación</p>
  //                 <select id="motivoCancelacion" class="swal2-select" style="width: 90%; margin-top: 10px;">
  //                   <option value="">Selecciona una opción</option>
  //                   <option value="errorDatos">Error de captura</option>
  //                   <option value="peticionCliente">Solicitud del Cliente</option>
  //                 </select>`,
  //     icon: "warning",
  //     iconColor: "#ED1B1B",
  //     showCancelButton: true,
  //     confirmButtonText: "Continuar",
  //     cancelButtonText: "Cancelar",
  //     customClass: {
  //       popup: "alert-bg custom-width",
  //       title: "alert-title",
  //       confirmButton: "btn-amc-blue",
  //       cancelButton: "btn-amc-pink",
  //     },
  //     preConfirm: () => {
  //       const motivo = document.getElementById("motivoCancelacion").value;
  //       if (!motivo) {
  //         Swal.showValidationMessage("Debes seleccionar un motivo");
  //         return false;
  //       }
  //       return motivo;
  //     },
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       if (result.value === "errorDatos") {
  //         goBackToBilling();
  //         Swal.fire({
  //           title: "¡La factura fue cancelada",
  //           icon: "success",
  //           iconColor: "#1B9925",
  //           customClass: {
  //             confirmButton: "btn-ok",
  //             title: "alert-title",
  //             popup: "alert-bg",
  //           },
  //         });
  //       } else if (result.value === "peticionCliente") {
  //         Swal.fire({
  //           title: "Detalles de Cancelación",
  //           html: `
  //                       <div class="container-fluid custom-modal-width">
  //                         <div class="row mb-3">
  //                           <div class="col-md-4 d-flex flex-column align-items-start">
  //                             <label for="inputSoloLectura"><strong>Monto a pagar:</strong></label>
  //                             <input id="inputSoloLectura" class="form-control" value="204.35" disabled style="width: 100%;" />
  //                           </div>
  //                           <div class="col-md-4 d-flex flex-column align-items-start">
  //                             <label for="select1"><strong>Agente/Almacén:</strong></label>
  //                             <select id="select1" class="form-select" style="width: 100%;">
  //                               <option value="">Seleccione una opción</option>
  //                               <option value="devolucion">Devolución</option>
  //                               <option value="ajuste">Ajuste</option>
  //                             </select>
  //                           </div>
  //                           <div class="col-md-4 d-flex flex-column align-items-start">
  //                             <label for="select2"><strong>Cliente a facturar:</strong></label>
  //                             <select id="select2" class="form-select" style="width: 100%;">
  //                               <option value="">Seleccione una opción</option>
  //                               <option value="opt1">Opción 1</option>
  //                               <option value="opt2">Opción 2</option>
  //                             </select>
  //                           </div>
  //                         </div>
              
  //                         <div class="row mb-3">
  //                           <div class="col-md-4 d-flex flex-column align-items-start">
  //                             <label for="select3"><strong>Condiciones de pago:</strong></label>
  //                             <select id="select3" class="form-select" style="width: 100%;">
  //                               <option value="">Seleccione...</option>
  //                               <option value="mayorista">Mayorista</option>
  //                               <option value="minorista">Minorista</option>
  //                             </select>
  //                           </div>
  //                           <div class="col-md-4 d-flex flex-column align-items-start">
  //                             <label for="inputEditable"><strong>Cuenta de crédito:</strong></label>
  //                             <input id="inputEditable" class="form-control" style="width: 100%;" />
  //                           </div>
  //                           <div class="col-md-4 d-flex flex-column align-items-start">
  //                             <label for="select4"><strong>Uso del CFDI:</strong></label>
  //                             <select id="select4" class="form-select" style="width: 100%;">
  //                               <option value="">Seleccione condición...</option>
  //                               <option value="ventas">Ventas</option>
  //                               <option value="soporte">Soporte</option>
  //                             </select>
  //                           </div>
  //                         </div>
              
  //                         <div class="row mb-3">
  //                           <div class="col-md-6 d-flex flex-column align-items-start">
  //                             <label for="select5"><strong>Método de pago:</strong></label>
  //                             <select id="select5" class="form-select" style="width: 85%;">
  //                               <option value="">Seleccione método...</option>
  //                               <option value="alta">Alta</option>
  //                               <option value="media">Media</option>
  //                               <option value="baja">Baja</option>
  //                             </select>
  //                           </div>
  //                           <div class="col-md-6 d-flex flex-column align-items-start">
  //                             <label for="textarea"><strong>Observaciones:</strong></label>
  //                             <textarea id="textarea" class="form-control" rows="3" style="width: 85%;"></textarea>
  //                           </div>
  //                         </div>
                          
  //                       </div>
  //                     `,
  //           showConfirmButton: true,
  //           confirmButtonText: "Enviar",
  //           showCancelButton: true,
  //           cancelButtonText: "Cancelar",
  //           customClass: {
  //             popup: "alert-bg custom-modalCancel-width",
  //             title: "alert-title",
  //             confirmButton: "btn-amc-blue",
  //             cancelButton: "btn-amc-pink",
  //           },
  //           preConfirm: () => {
  //             const metodoPago = document.getElementById("select5").value;
  //             const agente = document.getElementById("select1").value;
  //             const cliente = document.getElementById("select2").value;
  //             const condicionesPago = document.getElementById("select3").value;
  //             const cuentaCredito =
  //               document.getElementById("inputEditable").value;
  //             const usoCfdi = document.getElementById("select4").value;
  //             const observaciones = document.getElementById("textarea").value;

  //             if (!metodoPago || !agente || !cliente) {
  //               Swal.showValidationMessage(
  //                 "Completa los campos son obligatorios"
  //               );
  //               return false;
  //             }

  //             return {
  //               metodoPago,
  //               agente,
  //               cliente,
  //               condicionesPago,
  //               cuentaCredito,
  //               usoCfdi,
  //               observaciones,
  //             };
  //           },
  //           // didOpen: () => {
  //           //   document
  //           //     .getElementById("btnEnviar")
  //           //     .addEventListener("click", () => {
  //           //       goBackToBilling();
  //           //       Swal.fire({
  //           //         title: "¡La factura fue cancelada!",
  //           //         icon: "success",
  //           //         iconColor: "#1B9925",
  //           //         customClass: {
  //           //           popup: "alert-bg",
  //           //           confirmButton: "btn-ok",
  //           //           title: "alert-title",
  //           //         },
  //           //       });
  //           //     });

  //           //   document
  //           //     .getElementById("btnCancelar")
  //           //     .addEventListener("click", () => {
  //           //       Swal.close();
  //           //     });
  //           // },
  //         }).then((res2) => {
  //           if (res2.isConfirmed) {
  //             //Aqui se podria enviar los datos al backend
  //             console.log("Detalles de cancelacion:", res2.value);
  //             goBackToBilling();
  //             Swal.fire({
  //               title: "¡La factura fue cancelada!",
  //               icon: "success",
  //               iconColor: "#1B9925",
  //               customClass: {
  //                 confirmButton: "btn-ok",
  //                 title: "alert-title",
  //                 popup: "alert-bg",
  //               },
  //             });
  //           }
  //         });
  //       }
  //     }
  //   });
  // };

  const deleteFacturaTemp = (goBackToBilling) => {
    Swal.fire({
      title: "Cancelación",
      html: `<p><strong>Esta acción es irreversible</strong></p>
      <p>Si deseas continuar, selecciona el motivo de cancelación</p>
      <select id="motivoCancelacion" class="swal2-select" style="width: 90%; margin-top: 10px;">
        <option value="">Selecciona una opción</option>
        <option value="errorDatos">Error de captura</option>
        <option value="peticionCliente">Solicitud del Cliente</option>
      </select>`,
      icon: "warning",
      iconColor: "#ED1B1B",
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "alert-bg custom-width",
        title: "alert-title",
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
      },
      preConfirm: () => {
        const motivo = document.getElementById("motivoCancelacion").value;
        if (!motivo) {
          Swal.showValidationMessage("Debes seleccionar un motivo");
          return false;
        }
        return motivo;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === "errorDatos") {
          goBackToBilling();
          Swal.fire({
            title: "¡La factura fue cancelada!",
            icon: "success",
            iconColor: "#1B9925",
            customClass: {
              confirmButton: "btn-ok",
              title: "alert-title",
              popup: "alert-bg",
            },
          });
        } else if (result.value === "peticionCliente") {
          Swal.fire({
            title: "Detalles de Cancelación",
            html: `
            <div class="container-fluid custom-modal-width">
              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="inputSoloLectura"><strong>Monto a pagar:</strong></label>
                  <input id="inputSoloLectura" class="form-control" value="204.35" disabled />
                </div>
                <div class="col-md-4">
                  <label for="select1"><strong>Agente/Almacén:</strong></label>
                  <select id="select1" class="form-select">
                    <option value="">Seleccione una opción</option>
                    <option value="agente1">BERTHA M.ROJAS GAVIDA</option>
                    <option value="agente2">LUIS RUBEN PICAZO MANRIQUEZ</option>
                    <option value="agente3">ERNESTO RAMIREZ BARRERA</option>
                    <option value="agente4">Jose Manuel Gonzalez Valdéz</option>
                    <option value="agente5">AA MANUEL GONZALEZ VALDEZ</option>
                    <option value="agente6">RICARDO A. PRIETO CABEZA</option>
                    <option value="agente7">JOSE ARTURO MONTAUDON B.</option>
                    <option value="agente8">CARLOS GARCIA CARDOSO</option>
                    <option value="agente9">JORGE ZENDEJAS RODRIGUEZ</option>
                    <option value="agente10">HUGO EVERARDO GALINDO SOMMERZ</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="select2"><strong>Cliente a facturar:</strong></label>
                  <select id="select2" class="form-select">
                    <option value="">Seleccione una opción</option>
                    <option value="cliente1">AAACESA ALMACENES FISCALIZADOS SA DE CV</option>
                    <option value="cliente2">SONY COMERCIO DE MEXICO SA DE CV</option>
                    <option value="cliente3">ABASTECEDORA CAMIONERA SA DE CV</option>
                    <option value="cliente4">DHL EXPRESS MEXICO SA DE CV</option>
                    <option value="cliente5">SERINTEXP S DE RL DE CV</option>
                    <option value="cliente6">DIRECT GLOBALCARGO SA DE CV</option>
                    <option value="cliente7">ORTHO-CLINICAL DIAGNOSTICS MEXICO OPERATIONS S DE RL DE CV</option>
                    <option value="cliente8">SENATOR LOGISTICS SA DE CV</option>
                    <option value="cliente9">AEROLITORAL 0000</option>
                    <option value="cliente10">MABV INTERNATIONAL LOGISTICS SA DE CV</option>
                  </select>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="select3"><strong>Condiciones de pago:</strong></label>
                  <select id="select3" class="form-select">
                    <option value="">Seleccione...</option>
                    <option value="contado">Contado</option>
                    <option value="credito">Crédito</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label for="inputEditable"><strong>Cuenta de crédito:</strong></label>
                  <input id="inputEditable" class="form-control" />
                </div>
                <div class="col-md-4">
                  <label for="select4"><strong>Uso del CFDI:</strong></label>
                  <select id="select4" class="form-select">
                    <option value="">Seleccione condición ...</option>
                    <option value="op1">G03 - Gastos en general</option>
                    <option value="op2">G01 - Adquisición de mercancias</option>
                    <option value="op3">I08 - Otra maquinaria y equipo</option>
                    <option value="op4">S01 - Sin efectos fiscales</option>
                    <option value="op5">I05 - Dados, troqueles, moldes, matrices y herramientas</option>
                    <option value="op6">G02 - Devoluciones, descuentos o bonificaciones</option>
                    <option value="op7">CP01 - Pagos</option>
                  </select>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="select5"><strong>Método de pago:</strong></label>
                  <select id="select5" class="form-select">
                    <option value="">Seleccione método...</option>
                    <option value="pue">Pago en una sola exhibición</option>
                    <option value="ppd">Pago en parcialidades</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label for="textarea"><strong>Observaciones:</strong></label>
                  <textarea id="textarea" class="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
          `,
            showConfirmButton: true,
            confirmButtonText: "Enviar",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            customClass: {
              popup: "alert-bg custom-modalCancel-width",
              title: "alert-title",
              confirmButton: "btn-amc-blue",
              cancelButton: "btn-amc-pink",
            },
            didOpen: () => {
              // Activar filtro de búsqueda solo en los selects select1 y select2
              const searchableSelects = ["select1", "select2"];
              searchableSelects.forEach((id) => {
                const el = document.getElementById(id);
                if (el) {
                  new Choices(el, {
                    searchEnabled: true,
                    itemSelectText: "",
                  });
                }
              });
            },
            preConfirm: () => {
              const metodoPago = document.getElementById("select5").value;
              const agente = document.getElementById("select1").value;
              const cliente = document.getElementById("select2").value;

              if (!metodoPago || !agente || !cliente) {
                Swal.showValidationMessage("Completa los campos obligatorios");
                return false;
              }

              return {
                metodoPago,
                agente,
                cliente,
                condicionesPago: document.getElementById("select3").value,
                cuentaCredito: document.getElementById("inputEditable").value,
                usoCfdi: document.getElementById("select4").value,
                observaciones: document.getElementById("textarea").value,
              };
            },
          }).then((res2) => {
            if (res2.isConfirmed) {
              console.log("Detalles de cancelación:", res2.value);
              goBackToBilling();
              Swal.fire({
                title: "¡La factura fue cancelada!",
                icon: "success",
                iconColor: "#1B9925",
                customClass: {
                  confirmButton: "btn-ok",
                  title: "alert-title",
                  popup: "alert-bg",
                },
              });
            }
          });
        }
      }
    });
  };

  return (
    <>
      <div className="container-fluid">
        {/* primer fila (solo se muestran los datos de la guia)*/}
        <div className="row">
          <div className="col-12 mt-4">
            <div className="row">
              {[
                { label: "Master", value: "ABC123" },
                { label: "Origen", value: "MEX" },
                { label: "Destino", value: "MAD" },
                { label: "Tipo de mercancía", value: "Perecedero" },
                { label: "Piezas Master", value: "500" },
                { label: "Peso Master", value: "100" },
                { label: "HBS", value: "HBS1" },
                { label: "Piezas House", value: "50" },
                { label: "Peso House", value: "50" },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`pb-3 pb-md-5 ${
                    item.label === "Tipo de mercancía" ? "col-md-3" : "col-md-3"
                  }`}
                >
                  <span className="fw-bold">{item.label}: </span>
                  {item.value}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* segunda fila se muestra una tabla*/}
        <div className="row">
          {/* tabla 1 */}
          <table
            className="table text-center mx-auto"
            style={{ maxWidth: "700px", width: "100%" }}
          >
            <thead className="table fondo-head">
              <tr>
                <th>Folio</th>
                <th>Fecha</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dato 1</td>
                <td>Fecha 1</td>
                <td>
                  <button
                    className="botonCancelarTemp"
                    onClick={() => deleteFacturaTemp(goBackToBilling)}
                  >
                    <FaBan />
                  </button>

                  <button className="botonPrint" onClick={impresionTicket}>
                    <FaPrint />
                  </button>

                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end mt-3" style={{ maxWidth: "885px", width: "100%" }}>
          <button className="btnn" onClick={handleNuevaFactura}>Nueva factura</button>
        </div>
      </div>
    </>
  );
}

export default ReportTemperature;
